<template>
  <div class="min-h-screen bg-[#fffffc]">
    <router-view />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'AuthLayout',
});
</script>
